// import Layout from '@/baseLayout/LayoutPage'

/**
 * 管理员路由
  */

const adminRole = "admin"
const adminGroupOne = "奖学金申请"
const adminGroupTwo = "奖学金评审"
const adminGroupThree = "基础信息"
export const routesAd = {
    path: "/admin",
    name:"admin",
    // component:Layout,
    redirect:"/admin/teamsList",
    children:[
            // 奖学金申请
            {
                path: 'applylist',
                // component: () => import(/* webpackChunkName: "about" */ '../views/admin/ApplyListView.vue'),
                meta:{title:"申请列表",menuShow:true,"group":adminGroupOne,'role':adminRole}
            },
            {
                path: 'applydetail',
                // component: () => import(/* webpackChunkName: "about" */ '../views/admin/ApplyDetailView.vue'),
                meta:{title:"申请详情",menuShow:false,"group":adminGroupOne,'role':adminRole}
            },
            //奖学金评审 todo
            {
                path: 'judgegroup',
                // component: () =>import(/* webpackChunkName: "about" */ '../views/admin/JudgeGroupView.vue'),
                meta:{title:"分组管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
            },
            {
                path: 'Judgerule',
                // component: () => import(/* webpackChunkName: "about" */ '../views/admin/JudgeRuleView.vue'),
                meta:{title:"打分标准",menuShow:true,"group":adminGroupTwo,'role':adminRole}
            },
        {
            path: 'JudgeResult',
            // component: () => import(/* webpackChunkName: "about" */ '../views/admin/JudgeResultView.vue'),
            meta:{title:"评分结果",menuShow:true,"group":adminGroupTwo,'role':adminRole}
        },
// 基础信息
        //  申请人列表
        {
            path: 'students',
            // component: () => import(/* webpackChunkName: "about" */ '../views/admin/StudentListView.vue'),
            meta:{title:"注册用户","group":adminGroupThree,menuShow:true,'role':adminRole}
        },
            {
                path: 'userlist',
                // component: () => import(/* webpackChunkName: "about" */ '../views/admin/UserlistView.vue'),
                meta:{title:"账号管理",menuShow:true,"group":adminGroupThree,'role':adminRole}
            },
        {
            path: 'roles',
            // component: () => import(/* webpackChunkName: "about" */ '../views/admin/RoleListView.vue'),
            meta:{title:"角色管理",menuShow:true,"group":adminGroupThree,'role':adminRole}
        }
    ]
}


